import { fetchParcel } from '../../../store/actions/parcels';
import { getParcelData } from '../../../store/orm/Parcel/selectors';
import { createLoadAsyncAction } from '../../../utils/actionCreator';

export const fetchCacheableParcel = createLoadAsyncAction(
  (state, { match }) => getParcelData(state, match.params.parcelId),
  ({ match }) => fetchParcel(match.params.parcelId)
);
